export function getInitials(name: string | null | undefined): string {
  // Handle null, undefined, empty or whitespace-only strings
  if (!name || typeof name !== 'string' || name.trim() === '') {
    return 'U'
  }

  const trimmedName = name.trim()
  const nameParts = trimmedName.split(' ').filter(part => part.length > 0)

  // Ensure we have at least one valid part
  if (nameParts.length === 0) {
    return 'U'
  }

  const firstName = nameParts[0]
  const lastName = nameParts[1]

  // Safe access with fallback
  const firstInitial = firstName?.[0]?.toUpperCase() ?? 'U'
  const lastInitial = lastName?.[0]?.toUpperCase() ?? ''

  return `${firstInitial}${lastInitial}`
}
